import { FC, ReactNode } from 'react'
import AuthState from './AuthState'
import ShopState from './ShopState'
import SearchState from './SearchState'
import FeedBackState from './FeedBackState'
import LogState from './LogState'

const State: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <AuthState>
      <FeedBackState>
        <SearchState>
          <LogState>
            <ShopState>{children}</ShopState>
          </LogState>
        </SearchState>
      </FeedBackState>
    </AuthState>
  )
}

export default State
